import { createFileRoute } from "@tanstack/react-router";
import DepressedAndAnxious from "@/pages/articles/DepressedAndAnxious";
export const Route = createFileRoute("/depressed-and-anxious-at-the-same-time")(
  {
    component: RouteComponent,
    head() {
      return {
        meta: [
          {
            title:
              "Depressed And Anxious At The Same Time | Neuro Wellness TMS",
          },
          {
            name: "description",
            content:
              "Depression and anxiety often occur together. Learn how TMS, SAINT TMS, and other treatments address both conditions in Coral Springs, FL Free consultation.",
          },
          {
            property: "og:title",
            content:
              "Depressed And Anxious At The Same Time | Neuro Wellness TMS",
          },
          {
            property: "og:description",
            content:
              "Depression and anxiety often occur together. Learn how TMS, SAINT TMS, and other treatments address both conditions in Coral Springs, FL Free consultation.",
          },
          {
            property: "og:url",
            content:
              "https://neurowellnesstms.com/depressed-and-anxious-at-the-same-time",
          },
          {
            property: "og:type",
            content: "website",
          },
          {
            name: "twitter:card",
            content: "summary_large_image",
          },
        ],
        links: [
          {
            rel: "canonical",
            href: "https://neurowellnesstms.com/depressed-and-anxious-at-the-same-time",
          },
        ],
      };
    },
  },
);
function RouteComponent() {
  return <DepressedAndAnxious />;
}
